import * as React from 'react'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import logoPNG from 'assets/img/logo2.png'

const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
}))

export default function NoResultsOverlay() {
  const { t } = useTranslation()

  return (
    <StyledGridOverlay>
      <Box sx={{ px: 2, py: 1 }}>
        <Box
          component="img"
          src={logoPNG}
          alt="logo"
          sx={{
            width: 'auto',
            height: { xs: 50 },
          }}
        />
      </Box>
      <Typography variant="caption" sx={{ mt: 1 }}>
        {t('tables.responses.notFound')}
      </Typography>
    </StyledGridOverlay>
  )
}
